import { NgForOf } from '@angular/common';
import { Component } from '@angular/core';
import { ScrollService } from '../../../models/scroll-service';
import { TranslateModule } from '@ngx-translate/core';
import { AnimateOnScrollDirective } from '../../shared/animate-on-scroll.directive';


@Component({
  selector: 'app-my-skills',
  standalone: true,
  imports: [NgForOf, TranslateModule, AnimateOnScrollDirective],
  templateUrl: './my-skills.component.html',
  styleUrl: './my-skills.component.scss'
})
export class MySkillsComponent {

  constructor(private scrollService: ScrollService) { }

  skillImgs: string[] = [
    'assets/img/icons/angular.svg',
    'assets/img/icons/type-script.svg',
    'assets/img/icons/java-script.svg',
    'assets/img/icons/html.svg',
    'assets/img/icons/css.svg',
    'assets/img/icons/api.svg',
    'assets/img/icons/firebase.svg',
    'assets/img/icons/git.svg',
    'assets/img/icons/material-design.svg'
  ];

  skillImgsMobile: string[] = [
    'assets/img/icons/angular-mobile.svg',
    'assets/img/icons/typescript-mobile.svg',
    'assets/img/icons/javascript-mobile.svg',
    'assets/img/icons/html.mobile.svg',
    'assets/img/icons/css.mobile.svg',
    'assets/img/icons/api-mobile.svg',
    'assets/img/icons/firebase-mobile.svg',
    'assets/img/icons/git-mobile.svg',
    'assets/img/icons/material-design-mobile.svg'
  ]


  goToContact() {
    this.scrollService.scrollToId('contact-me');
  }


  getChallengeDelay() {
    const maxIndex = Math.max(this.skillImgs.length, this.skillImgsMobile.length);
    return maxIndex * 100;
  }

}
